module.exports = __webpack_public_path__ + "static/logo-7ca36dbaea637eb2a0b01cdef85c46dc.png";